import {
    USER_GETALL_SUCCESS,
    USER_GETALL_FAIL,
    USER_DELETE_SUCCESS,
    USER_DELETE_FAIL,
    USER_UPSERT_SUCCESS,
    USER_UPSERT_FAIL,
    SET_MESSAGE
  } from "./types";

import UserService from "../services/user.service";

export const getUsers = () => (dispatch) => {
    return UserService.getUsers().then(
      (data) => {
        dispatch({
          type: USER_GETALL_SUCCESS,
          payload: { users: data },
        });
  
        return Promise.resolve();
      },
      (error) => {  
        dispatch({
          type: USER_GETALL_FAIL,
        });
        dispatch({ type: SET_MESSAGE, payload: `Users retrieval failed : ${error}` });
    
  
        return Promise.reject();
      }
    );
  };

  export const deleteUser = (uid) => (dispatch) => {
    return UserService.deleteUser(uid).then(
      (data) => {
        if(data = 204)
        {
          dispatch({
            type: USER_DELETE_SUCCESS,
            payload: uid
          });
        }
        else
        {
          dispatch({
            type: USER_DELETE_FAIL,
          });
          dispatch({ type: SET_MESSAGE, payload: `User removal failed : ${data.response}` });
        }
        
  
        return Promise.resolve();
      },
      (error) => {
        dispatch({
          type: USER_DELETE_FAIL,
        });
  
        dispatch({ type: SET_MESSAGE, payload: `User removal failed : ${error}` });
  
        return Promise.reject();
      }
    );
  };

  export const putUser = (user) => (dispatch) => {
    return UserService.putUser(user).then(
      (data) => {
        dispatch({
          type: USER_UPSERT_SUCCESS,
          payload: data
        });
  
        return Promise.resolve();
      },
      (error) => {
        dispatch({
          type: USER_UPSERT_FAIL,
        });
        dispatch({ type: SET_MESSAGE, payload: `User upsert failed - ${error}` });
  
        return Promise.reject();
      }
    );
  };